import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

export const rememberUserGuard = () => {
  const cookieService = inject(CookieService);
  const router = inject(Router)
  const verfiedCookieUser = cookieService.get('HIT-user');
  if (verfiedCookieUser) {
    router.navigate(['profile'])
  }
  return true;
};
